import { useEffect, useState } from "react";
import { useApp } from "../context/AppContext";
import { getContent } from "../lib/api";
import { ChevronLeft, ChevronRight, BookOpen } from "lucide-react";

export default function Quran() {
  const { t, lang } = useApp();
  const [verses, setVerses] = useState([]);
  const [idx, setIdx] = useState(0);

  useEffect(() => { getContent("verses").then(setVerses); }, []);
  if (!verses.length) return <div className="p-6">…</div>;

  const v = verses[idx];
  const next = () => setIdx((idx + 1) % verses.length);
  const prev = () => setIdx((idx - 1 + verses.length) % verses.length);

  return (
    <div className="space-y-6 fade-in" data-testid="quran-page">
      <header className="flex items-center gap-3">
        <div className="w-12 h-12 rounded-2xl bg-nour-primary text-white flex items-center justify-center"><BookOpen className="w-6 h-6" /></div>
        <div>
          <h1 className="font-heading text-2xl font-bold">{t.quran}</h1>
          <p className="text-sm text-nour-text2">{v.surah} — {v.ayah}</p>
        </div>
      </header>

      <article className="nour-card p-6 sm:p-10 geo-watermark" data-testid="quran-verse-card">
        <div className="font-arabic-quran text-3xl sm:text-4xl text-center text-nour-primary leading-relaxed" dir="rtl" data-testid="verse-arabic">
          {v.ar}
        </div>
        <div className="divider-soft my-6" />
        <div className="text-sm text-nour-text2 italic text-center">{v.translit}</div>
        <div className="text-base sm:text-lg text-nour-text text-center mt-3" data-testid="verse-translation">
          {v[lang] || v.fr}
        </div>
      </article>

      <div className="flex items-center justify-between">
        <button className="btn-ghost" onClick={prev} data-testid="verse-prev"><ChevronLeft className="w-4 h-4" /> {t.previous}</button>
        <span className="text-sm text-nour-text2">{idx + 1} / {verses.length}</span>
        <button className="btn-primary" onClick={next} data-testid="verse-next">{t.next} <ChevronRight className="w-4 h-4" /></button>
      </div>
    </div>
  );
}
